export enum PurchaseSubmitStatus {
    NOT_SUBMITTED = 'NOT_SUBMITTED',
    SUBMIT_SUCCESS = 'SUBMIT_SUCCESS',
    SUBMIT_FAILURE = 'SUBMIT_FAILURE',
}
